// This file (and its related code) was extracted from `src/rxdb/syncReplicationStatesWithGraphQL.ts`
import { WithDeleted } from 'rxdb';

import { formatDateToUnix } from '../../../utilities/hooks/useDateFormatters';
import { PullModifier } from '../replicate';
import {
  BorerOperatorState,
  BorerOperatorStateBase,
  isBorerOperatorStateBase,
} from './queryBuilder';

export const pullModifier: PullModifier<BorerOperatorState> = doc => {
  // BUG: Turns out that `doc` is often not a `BorerOperatorStateBase`.
  if (!isBorerOperatorStateBase(doc)) {
    // Need to log this to investigate.
    // eslint-disable-next-line no-console
    console.debug('Bad BorerOperatorStateBase', doc);
  }
  const base = doc as BorerOperatorStateBase;
  const result: WithDeleted<BorerOperatorState> = {
    ...base,
    startTimeUnix: formatDateToUnix(base.startTime),
    endTimeUnix: base.endTime ? formatDateToUnix(base.endTime) : undefined,
    showInSchedulerView: true,
    _deleted: base.isDeleted,
  };
  return result;
};
